import startCase from "lodash/startCase";
import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";

export const accountTypeToHumanReadable = (
  accountType: bankingApiSpec.InternalAccountType
) => {
  switch (accountType) {
    case "Banking":
      return "Wingspan Wallet";
    case "Clearing":
      return "Clearing";
    case "TaxWithholding":
      return "Tax Withholding";
    case "CardClearing":
      return "Card Clearing";
    case "InternationalClearing":
      return "International Clearing";
    default:
      return startCase(accountType);
  }
};
